export default __webpack_public_path__ + "static/media/3.c1581a31.webp";